export const messages: any = {
  ru: {
    heading: 'Система регистрации мобильных устройств',
    register: 'Зарегистрировать устройство',
    registerDescription:
      'Онлайн регистрация мобильного устройства по номеру izi и ИИН',
    unregister: 'Снять устройство с регистрации',
    unregisterDescription: 'Убрать со своего номера и ИИН текущее устройство',
    deviceList: 'Список устройств',
    deviceListDescription:
      'Посмотреть список зарегистрированных устройств по номеру izi',
    reregister: 'Перерегистрировать устройство',
    reregisterDescription:
      'Передача мобильного устройства от текущего владельца абоненту izi',
    deviceName: 'Модель устройства',
    checkModal: 'Проверить устройство',
    checkModalDescription: 'Проверить зарегистрированное устройство по IMEI',
    smsConfirmButton: 'Подтвердить',
    smsConfirmLabel: 'Введи код из SMS',
    smsRequestOtpButton: 'Запросить еще раз',
    requestOtpAgain: 'Повторный запрос SMS-кода через',
    closeModal: 'Закрыть',
    faq: {
      title: 'Ответы на частые вопросы'
    },
    fields: {
      owner: 'ИИН или номер паспорта (для иностранцев)',
      ownerValidation: 'Введи ИИН или номер паспорта (для иностранцев)',
      msisdn: 'Номер izi',
      msisdnValidation: 'Введи номер izi',
      prevMsisdn: 'Номер прежнего владельца',
      prevMsisdnValidation: 'Введи номер прежнего владельца',
      prevOwnerValidation: 'Введи ИИН предыдущего владельца',
      newOwnerValidation: 'Введи ИИН нового владельца',
      prevOwnerDocType: 'Тип документа прежнего владельца',
      newOwnerDocType: 'Тип документа нового владельца',
      imei: 'Код мобильного устройства (IMEI)',
      imeiValidation: 'IMEI должен состоять из 15 цифр',
      prevOwner: {
        iin: 'Номер ИИН',
        bin: 'Номер БИН',
        rnn: 'Номер РНН',
        passportResident: 'Номер паспорта резидента',
        passportNonResident: 'Номер паспорта нерезидента'
      },
      select: {
        default: 'Выберите значение',
        iin: 'ИИН',
        bin: 'БИН',
        rnn: 'РНН',
        passportResident: 'Паспорт резидента',
        passportNonResident: 'Паспорт нерезидента'
      }
    },
    modalRegister: {
      header: 'Регистрация устройства',
      button: 'Зарегистрировать'
    },
    modalUnregister: {
      header: 'Снятие устройства с регистрации',
      button: 'Снять с регистрации'
    },
    modalList: {
      header: 'Список устройств',
      button: 'Показать'
    },
    modalCheck: {
      header: 'Проверка устройства',
      button: 'Проверить',
      true: "Устройство зарегистрировано",
      false: "Устройство не зарегистрировано",
      error: "Не удалось проверить устройство"
    },
    modalReregister: {
      header: 'Перерегистрировать устройство',
      button: 'Перерегистрировать',
      warning:
        'Важно! Во время совершения операции SIM карта должна быть вставлена в устройство'
    },
    devicesPage: {
      helperText: 'Это последнее устройство, обнаруженное по номеру +{msisdn}.'
    },
    techWork: 'Сервис временно недоступен. <br> Ведутся технические работы в период с 06.12.2023 20:30 вечера до 07.12.2023 06:30 утра. <br> Приносим извинения за неудобства.    '
  },
  en: {
    heading: 'Mobile device registration system',
    register: 'Register device',
    registerDescription:
      'Online registration of a mobile device by izi number and IIN',
    unregister: 'Unregister device',
    unregisterDescription: 'Remove the current device from your number and IIN',
    deviceList: 'Device list',
    deviceListDescription: 'View the list of registered devices by izi number',
    reregister: 'Re-register device',
    reregisterDescription:
      'Transfer of a mobile device from the current owner to an izi subscriber',
    deviceName: 'Device model',
    smsConfirmButton: 'Confirm',
    smsConfirmLabel: 'Enter the code from SMS',
    smsRequestOtpButton: 'Request again',
    requestOtpAgain: 'Re-request SMS code after',
    closeModal: 'Close',
    faq: {
      title: 'Frequently asked questions'
    },
    fields: {
      owner: 'IIN or passport number (for foreigners)',
      ownerValidation: 'Enter the IIN or passport number (for foreigners)',
      msisdn: 'izi mobile number',
      msisdnValidation: 'Enter izi mobile number',
      prevMsisdn: 'Number of the previous owner',
      prevMsisdnValidation: 'Enter number of the previous owner',
      prevOwnerValidation: 'Enter IIN of the previous owner',
      newOwnerValidation: 'Enter IIN of the new owner',
      prevOwnerDocType: 'Document type of the previous owner',
      newOwnerDocType: 'Document type of the new owner',
      prevOwner: {
        iin: 'IIN number',
        bin: 'BIN number',
        rnn: 'TIN number',
        passportResident: 'Resident passport number',
        passportNonResident: 'Non resident passport number'
      },
      select: {
        default: 'Select an option',
        iin: 'IIN',
        bin: 'BIN',
        rnn: 'TIN',
        passportResident: 'Resident passport',
        passportNonResident: 'Non resident passport'
      }
    },
    modalRegister: {
      header: 'Device registration',
      button: 'Register'
    },
    modalUnregister: {
      header: 'Unregister a device',
      button: 'Unregister'
    },
    modalList: {
      header: 'Device list',
      button: 'Show'
    },
    modalReregister: {
      header: 'Re-register device',
      button: 'Re-register',
      warning:
        'Important! During the operation, the SIM card must be inserted into the device'
    },
    devicesPage: {
      helperText: 'This is a last device detected by +{msisdn}.'
    },
    techWork: 'The service is temporarily unavailable. <br> Technical work is under way from 06.12.2023 20:30 PM to 07.12.2023 06:30 AM. <br> Sorry about the inconvenience.'

  },
  kk: {
    heading: 'Мобильді тіркеу жүйесі',
    register: 'Құрылғыны тіркеу',
    registerDescription:
      'izi нөмірі мен ЖСН бойынша мобильді құрылғыны онлайн тіркеу',
    unregister: 'Құрылғыны тіркеуден шығару',
    unregisterDescription:
      'Ағымдағы құрылғыны нөміріңізден және ЖСН-дан алыңыз',
    deviceList: 'Құрылғылар тізімі',
    deviceListDescription:
      'Тіркелген құрылғылар тізімін izi нөмірі бойынша қарау',
    reregister: 'Құрылғыны қайта тіркеу',
    reregisterDescription:
      'Мобильді құрылғыны қазіргі иесінен izi абонентке беру',
    deviceName: 'Құрылғы моделі',
    smsConfirmButton: 'Растау',
    smsConfirmLabel: 'SMS кодын енгізіңіз',
    smsRequestOtpButton: 'Тағы да сұраңыз',
    requestOtpAgain: 'SMS кодын қайта сұрау',
    closeModal: 'Жабық',
    faq: {
      title: 'Жиі қойылатын сұрақтар'
    },
    fields: {
      owner: 'ЖСН немесе паспорт нөмірі (шетелдіктер үшін)',
      ownerValidation:
        'ЖСН немесе паспорт нөмірін енгізіңіз (шетелдіктер үшін)',
      msisdn: 'izi нөмірі',
      msisdnValidation: 'izi нөмірі енгізу',
      prevMsisdn: 'Алдыңғы иесінің нөмірі',
      prevMsisdnValidation: 'Алдыңғы иесінің нөмірін енгізіңіз',
      prevOwnerValidation: 'Алдыңғы иесінің ЖСН енгізіңіз',
      newOwnerValidation: 'Жаңа иесінің ЖСН енгізіңіз',
      prevOwnerDocType: 'Алдыңғы иесінің құжат түрі',
      newOwnerDocType: 'Жаңа иесінің құжат түрі',
      prevOwner: {
        iin: 'ЖСН нөмірі',
        bin: 'БСН нөмірі',
        rnn: 'СТН нөмірі',
        passportResident: 'Резиденттің төлқұжат нөмірі',
        passportNonResident: 'Резидент емес төлқұжат нөмірі'
      },
      select: {
        default: 'Мәнді таңдаңыз',
        iin: 'ЖСН',
        bin: 'БСН',
        rnn: 'СТН',
        passportResident: 'Тұрғынның төлқұжаты',
        passportNonResident: 'Резидент еместің паспорты'
      }
    },
    modalRegister: {
      header: 'Құрылғыны тіркеу',
      button: 'Тіркелу'
    },
    modalUnregister: {
      header: 'Құрылғыны тіркеуден шығарыңыз',
      button: 'Тіркеуден шығару'
    },
    modalList: {
      header: 'Тіркелген құрылғылар тізімі',
      button: 'Көрсету'
    },
    modalReregister: {
      header: 'Құрылғыларды қайта тіркеу',
      button: 'Қайта тіркеу',
      warning:
        'Important! During the operation, the SIM card must be inserted into the device'
    },
    devicesPage: {
      helperText: 'Бұл +{msisdn} нөмірі бойынша анықталған соңғы құрылғы.'
    },
    techWork: 'Сервис уақытша қолжетімді емес.<br> Техникалық жұмыстар желтоқсанның 6-сы кешкі 20:30-дан бастап желтоқсанның 7-сі таңғы 06:30-ға дейін жүргізіледі.<br> Қолайсыздық үшін кешірім өтінеміз.'

  }
}
